import {certificateElementType} from "~/enums/certificateElementType";
import TextElement from "./concerns/textElement";
import DynamicModeCertificateElement from "./dynamicCertificateElement";

export default class DynamicModeTextCertificateElement extends TextElement(DynamicModeCertificateElement){
  type: certificateElementType = certificateElementType.DynamicModeText;

  clearRepeatableInputs(){
    const $htmlClone = $(this.html).clone()
    //deletes the repeatable pills from the HTML
    $htmlClone.find(".repeatable").each((index, element) => element.remove())
    //Need to set this.html to a string otherwise Froala will throw error
    this.html = $htmlClone.wrap('<div/>').parent().html()
  }

  get isConfiguredToRepeatableInput() : boolean{
    return $(this.html).find(".repeatable").length > 0
  }

}